"use strict";

import Vue from 'vue';
const PackageInfo = require('./package');
const merge = require('webpack-merge');
const store = require('./' + PackageInfo.name + '/store/app');
import 'babel-polyfill';

// noinspection JSUnresolvedVariable
Vue.config.productionTip = (process.env.NODE_ENV !== "production");

Vue.prototype.$toCssUrl = function (imageUrl) {
    return "url(" + imageUrl + ")";
};
Vue.prototype.$toCssBackgroundImage = function (imageUrl) {
    return {
        backgroundImage : this.$toCssUrl(imageUrl),
    };
};

const SlimvueFunc = {
    DEBUG_LOG_LEVEL   : 0,
    DEFAULT_LOG_LEVEL : 10,
    INFO_LOG_LEVEL    : 20,
    WARNING_LOG_LEVEL : 30,
    ERROR_LOG_LEVEL   : 40,
    _logLevel         : -1,
    set logLevel(val) {
        this._logLevel = val;
    },
    get logLevel() {
        if (this._logLevel === -1) {
            return this.isDebug ? this.DEBUG_LOG_LEVEL : this.INFO_LOG_LEVEL;
        }
        else {
            return this._logLevel;
        }
    },
    get isDebug() {
        return process.env.NODE_ENV !== "production";
    },
    get bridge() {
        if (undefined === window.bridge) {
            return process.env.bridge;
        }
        else {
            return window.bridge;
        }
    },
    mount             : function (vueComponent) {
        let app = window.slimvue = new Vue({
            components: {
                vueComponent,
            },
            store: store.default,
            template: '<div class="oasispay-website-box"><vueComponent></vueComponent></div>',
            el: "#oasis-payment-pay",
            i18n: store.default.state.$i18n
        });

        return app;
    },
    log               : function (...args) {
        if (this.logLevel <= this.DEFAULT_LOG_LEVEL) console.log(...args);
    },
    debug             : function (...args) {
        if (this.logLevel <= this.DEBUG_LOG_LEVEL) console.debug(...args);
    },
    info              : function (...args) {
        if (this.logLevel <= this.INFO_LOG_LEVEL) console.info(...args);
    },
    warn              : function (...args) {
        if (this.logLevel <= this.WARNING_LOG_LEVEL) console.warn(...args);
    },
    error             : function (...args) {
        if (this.logLevel <= this.ERROR_LOG_LEVEL) console.error(...args);
    },
};

//合并对象并输出对象
export default merge(store.default.state.$common, SlimvueFunc);



// WEBPACK FOOTER //
// ./slimvue.js